import Head from "next/head";
import DefaultLayout from "@/components/DefaultLayout";
import SliderBarLeft from "@/components/SliderBarLeft";
import SliderBarRight from "@/components/SliderBarRight";
import ArticleTemplate from "@/components/article/ArticleTemplate";
import styles from "@/styles/article/return-policy.module.scss";

export default function PaymentPolicy() {

  return (
    <>
      <Head>
        <title>Payment Policy - BestDeals.co.nz</title>
      </Head>

      <DefaultLayout>
        <div className={`${styles["page-return-policy"]} slider-wapper`}>
          <SliderBarLeft />
          <SliderBarRight />

          <ArticleTemplate articleName={"PaymentPolicy"} />
        </div>
      </DefaultLayout>
    </>
  );
}
